import { useMutation } from "@tanstack/react-query";

import { useAxios, useApiResponseParser } from "../";

export interface CreateAttributeParams {
    ProjectId: string;
    AttributeName: string;
    Value?: any;
    Qty?: number;
    Action?: string;
    CalculatedValue?: number;
}

export interface ListAttributesParams {
    ProjectId: string;
}

export interface UpdateAttributeParams {
    Id: string;
    AttributeName?: string;
    Value?: any;
    Qty?: number;
    Action?: string;
    CalculatedValue?: number;
}

export default function useInspectionAttributes() {
    const { axiosPrivate } = useAxios();
    const { parseSuccessResponseData } = useApiResponseParser();

    function useCreate() {
        return useMutation({
            mutationFn: (parameters: CreateAttributeParams) =>
                axiosPrivate.post(`/v1/inspection-attribute/create`, parameters).then(parseSuccessResponseData),
        });
    }

    function useListByProjectId() {
        return useMutation({
            mutationFn: (params: ListAttributesParams) =>
                axiosPrivate.get(`/v1/inspection-attribute/list`, { params }).then(parseSuccessResponseData),
        });
    }

    function useUpdateSingleAttribute() {
        return useMutation({
            mutationFn: (params: UpdateAttributeParams) =>
                axiosPrivate.put(`/v1/inspection-attribute/update`, params).then(parseSuccessResponseData),
        });
    }

    function useDeleteSingleAttribute() {
        return useMutation({
            mutationFn: (id: string) =>
                axiosPrivate.delete(`/v1/inspection-attribute/delete/${id}`).then(parseSuccessResponseData),
        });
    }

    return { useCreate, useListByProjectId, useUpdateSingleAttribute, useDeleteSingleAttribute };
}
